var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4189 14.7321C20.4189 18.3101 18.3099 20.4191 14.7319 20.4191H6.94988C3.36288 20.4191 1.24988 18.3101 1.24988 14.7321V6.93211C1.24988 3.35911 2.56388 1.25011 6.14288 1.25011H8.14288C8.86088 1.25111 9.53688 1.58811 9.96688 2.16311L10.8799 3.37711C11.3119 3.95111 11.9879 4.28911 12.7059 4.29011H15.5359C19.1229 4.29011 20.4469 6.11611 20.4469 9.76711L20.4189 14.7321Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48096 13.463H15.216",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.2b788a1f75e5f31aa8a6f6d965bec581.svg";
export { ForwardRef as ReactComponent };